export const ACCEPTED_FILE_TYPES = 'image/*,application/pdf,video/mp4,audio/*'
